<template>
  <div class="status-filter-container">
    <div class="status-filter-header">
      <div class="status-filter-title">Status Filters:</div>
      <label class="show-red-toggle">
        <input
          type="checkbox"
          v-model="showRedStatuses"
        />
        <span class="toggle-checkmark"></span>
        <span class="toggle-label">Show Red Statuses</span>
      </label>
    </div>
    <div class="status-filter-actions">
      <button class="submit-btn" @click="onStatusChange">Submit</button>
    </div>
    <div class="status-checkboxes">
      <label
        v-for="status in visibleStatusOptions"
        :key="status.value"
        class="status-checkbox-label"
        :class="{ 'red-status': status.isRed }"
      >
        <input
          type="checkbox"
          :value="status.value"
          v-model="selectedStatuses"
        />
        <span class="checkmark"></span>
        <span class="status-label">{{ status.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusFilter',
  data () {
    return {
      showRedStatuses: false,
      defaultStatusOptions: [
        { value: 'awaiting_company_sent', label: 'Awaiting Company Sent', isRed: false },
        { value: 'company_never_replied', label: 'Company Never Replied', isRed: false },
        { value: 'received_proposal', label: 'Received Proposal', isRed: false },
        { value: 'interview', label: 'Interview', isRed: false },
        { value: 'company_process', label: 'Company Process', isRed: false }
      ],
      redStatusOptions: [
        { value: 'expired_advanced', label: 'Expired Advanced', isRed: true },
        { value: 'company_rejected_advanced', label: 'Company Rejected Advanced', isRed: true },
        { value: 'applicant_rejected_advanced', label: 'Applicant Rejected Advanced', isRed: true },
        { value: 'expired_after_sent', label: 'Expired After Sent', isRed: true },
        { value: 'awaiting_company_later', label: 'Awaiting Company Later', isRed: true },
        { value: 'company_rejected_final', label: 'Company Rejected Final', isRed: true },
        { value: 'company_familiar', label: 'Company Familiar', isRed: true },
        { value: 'company_rejected', label: 'Company Rejected', isRed: true }
      ],
      selectedStatuses: []
    }
  },
  computed: {
    visibleStatusOptions () {
      if (this.showRedStatuses) {
        return [...this.defaultStatusOptions, ...this.redStatusOptions]
      }
      return this.defaultStatusOptions
    }
  },
  created () {
    // Initialize selected statuses from URL query or set all as default
    const queryStatuses = this.$route.query.statuses
    if (queryStatuses) {
      this.selectedStatuses = queryStatuses.split(',').map(s => s.trim())
      const hasRedStatus = this.selectedStatuses.some(status =>
        this.redStatusOptions.some(redOption => redOption.value === status)
      )
      if (hasRedStatus) {
        this.showRedStatuses = true
      }
    } else {
      this.selectedStatuses = this.defaultStatusOptions.map(option => option.value)
    }
  },
  methods: {
    onStatusChange () {
      // Update URL with selected statuses
      const statusesParam = this.selectedStatuses.length > 0
        ? this.selectedStatuses.join(',')
        : undefined

      const newQuery = { ...this.$route.query }
      if (statusesParam) {
        newQuery.statuses = statusesParam
      } else {
        delete newQuery.statuses
      }

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: newQuery
      })
    }
  }
}
</script>

<style scoped>
.status-filter-container {
  background: #f8f9fa;
  padding: 15px 20px;
  border-radius: 8px;
  margin: 20px 0;
  border: 1px solid #dee2e6;
}

.status-filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.status-filter-title {
  font-weight: bold;
  color: #495057;
  font-size: 14px;
}

.show-red-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  color: #6c757d;
  user-select: none;
}

.show-red-toggle input[type="checkbox"] {
  display: none;
}

.toggle-checkmark {
  height: 16px;
  width: 16px;
  background-color: #fff;
  border: 2px solid #dee2e6;
  border-radius: 3px;
  margin-right: 6px;
  position: relative;
  transition: all 0.2s ease;
}

.show-red-toggle:hover .toggle-checkmark {
  border-color: #dc3545;
}

.show-red-toggle input:checked ~ .toggle-checkmark {
  background-color: #dc3545;
  border-color: #dc3545;
}

.show-red-toggle input:checked ~ .toggle-checkmark:after {
  content: "";
  position: absolute;
  display: block;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.toggle-label {
  font-weight: 500;
}

.status-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.status-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
  user-select: none;
}

.status-checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 2px solid #dee2e6;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s ease;
}

.status-checkbox-label:hover .checkmark {
  border-color: #007bff;
}

.status-checkbox-label input:checked ~ .checkmark {
  background-color: #007bff;
  border-color: #007bff;
}

.status-checkbox-label input:checked ~ .checkmark:after {
  content: "";
  position: absolute;
  display: block;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.status-label {
  font-weight: 500;
}

.red-status {
  opacity: 0.9;
}

.red-status .checkmark {
  border-color: #dc3545;
}

.red-status .status-label {
  color: #dc3545;
}

.red-status:hover .checkmark {
  border-color: #c82333;
}

.red-status input:checked ~ .checkmark {
  background-color: #dc3545;
  border-color: #dc3545;
}

.status-filter-actions {
  margin-bottom: 10px;
}

.submit-btn {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.submit-btn:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .status-filter-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .status-checkboxes {
    flex-direction: column;
    gap: 10px;
  }

  .status-filter-container {
    margin: 10px 0;
    padding: 10px 15px;
  }
}
</style>
